export default __webpack_public_path__ + "fb96e0ee55596536a1060b813d7b5e93.png";